module.exports = __webpack_public_path__ + "static/media/TN-Men-Wallets-2.0.68e5ec3a.svg";